module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/Medical Examination/medical-examination-grid/medical-examination-grid.component.css
// module id = ./src/app/hrms/serviceregister/Medical Examination/medical-examination-grid/medical-examination-grid.component.css
// module chunks = main